import React from "react";
import { Switch } from "react-router";
import AdminLayout from "./AdminLayout";

import AdminDashboard from "./components/AdminDashboard";
import OfferingList from "./components/OfferingList";
import EligiblePool from "./components/EligiblePool/EligiblePool";
import ProgramSetup from "./components/ProgramSetup/ProgramSetup";
import MissionSetup from "./components/MissionSetup/MissionSetup";
import Reports from "./components/Reports/Reports";

const AdminApp = () => {
  return (
    <Switch>
      <AdminLayout path="/admin" component={<AdminDashboard />} exact />
      <AdminLayout
        path="/admin/dashboard"
        component={<AdminDashboard />}
        exact
      />
      <AdminLayout path="/admin/offerings" component={<OfferingList />} exact />
      <AdminLayout
        path="/admin/eligiblepool"
        component={<EligiblePool />}
        exact
      />
      <AdminLayout
        path="/admin/programSetup"
        component={<ProgramSetup />}
        exact
      />
      <AdminLayout
        path="/admin/missionSetup"
        component={<MissionSetup />}
        exact
      />
      <AdminLayout
        path="/admin/reports"
        component={<Reports />}
        exact
      />
    </Switch>
  );
};

export default AdminApp;
